// extracted by mini-css-extract-plugin
module.exports = {"row":"GreetingUser_row__VZTeA","container":"GreetingUser_container__ddo7I"};